import React, { PureComponent } from "react";
import {
  WithStyles,
  withStyles,
  createStyles,
  Theme,
  Grid,
  Typography,
} from "@material-ui/core";
import classNames from "classnames";

const styles = (theme: Theme) =>
  createStyles({
    fileName: {
      fontSize: "14px",
      color: "#333",
      fontWeight: "bold",
      maxWidth: 150,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      '&>img':{
        marginRight: '20px',
        verticalAlign: 'middle',
        height: '36px',
      }
    },
    extension: {
      textTransform: "uppercase",
      fontSize: "12px",
      color: "#999",
    },
    clickable: {
      cursor: "pointer",
    },
    PdfViewHeader:{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingRight: '40px'
    }
  });

interface Props extends WithStyles<typeof styles> {
  extension: string;
  fileName: string;
  url: string;
  itemsDownloadable?: boolean;
  showPdfView?: boolean;
  pdfPageData?: any;
  pdfType? : any;
}

class MyPATUploadPreviewItem extends PureComponent<Props> {
  renderItemIcon = (extension: string) => {
    let imagePath = "";
    switch (extension) {
      case "xls":
      case "xlsx": {
        imagePath = "/assets/svg/excelDocIcon.svg";
        break;
      }
      case "doc":
      case "docx": {
        imagePath = "/assets/svg/wordDocIcon.svg";
        break;
      }
      case "pdf": {
        imagePath = "/assets/svg/pdfDocIcon.svg";
        break;
      }
      default:
        break;
    }
    return <img src={imagePath} height="40" width="30" alt={extension} />;
  };
  handleItemClick = (url: string) => {
    window.open(url, "_blank");
  };
  capitalize(str: string){
    return str.charAt(0).toUpperCase() + str.slice(1);
    }
    
  render() {
    const { extension, classes, fileName, url, itemsDownloadable, showPdfView, pdfPageData, pdfType } = this.props;
    return (
      <Grid
        container
        className={classNames(itemsDownloadable && classes.clickable)}
        onClick={() => itemsDownloadable && this.handleItemClick(url)}
      >
        {!showPdfView && 
        <Grid item xs={3}>
          {this.renderItemIcon(extension)}
        </Grid>}
        <Grid className={classes.PdfViewHeader} item xs={!showPdfView ? 9 : 12}>
          {!showPdfView ? <>
          <Typography variant="subheading" className={classes.fileName}>
            {fileName}
          </Typography>
          <Typography variant="subtitle1" className={classes.extension}>
            {extension}
          </Typography>
          </> : <>
          <Typography variant="subheading" className={classes.fileName}>
            {pdfType === 'WorkBook' ? <img src="/assets/img/workbook-mob.svg"/> : <img src="/assets/img/pdfNotes.svg"/>}
            {this.capitalize(fileName)}.{extension}
          </Typography>
          <Typography variant="subheading" className={classes.fileName}>          
            Total Pages: {pdfPageData.totalPages}
          </Typography>
          </>
           }
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(MyPATUploadPreviewItem);